export default __webpack_public_path__ + "static/media/defi.17357c58.png";